export default __webpack_public_path__ + "meetingRoomInviteDetails1.json";